<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <h4>회원 검색</h4>

      <!-- 상단: 좌측 콤보(이름/로그인ID) + 입력, 우측 검색/닫기 -->
      <div class="search-bar">
        <select v-model="field">
          <option value="name">이름</option>
          <option value="loginId">로그인ID</option>
        </select>
        <input v-model="keyword" type="text" placeholder="검색어" @keyup.enter="doSearch" />
        <span class="spacer"></span>
        <button class="primary" @click="doSearch">검색</button>
        <button class="ghost" @click="close">닫기</button>
      </div>

      <p v-if="message" class="error">{{ message }}</p>

      <!-- 중단: 결과 테이블 (이름 / 로그인ID / 노드명) -->
      <div class="result-box">
        <table class="grid">
          <thead>
            <tr><th></th><th>이름</th><th>로그인ID</th><th>노드명</th></tr>
          </thead>
          <tbody>
            <tr v-for="r in results" :key="r.id"
                :class="{sel: selected && selected.id===r.id}" @click="pick(r)">
              <td class="center"><input type="radio" :checked="selected && selected.id===r.id" /></td>
              <td>{{ r.name }}</td>
              <td>{{ r.loginId }}</td>
              <td>{{ r.nodeName || r.name }}</td>
            </tr>
            <tr v-if="results.length===0"><td colspan="4" class="empty">검색 결과 없음</td></tr>
          </tbody>
        </table>
      </div>

      <!-- 페이징 (화면 공통 위젯: 맨앞 이전 1..5 다음 맨뒤 + 10/20/30/40/50 콤보) -->
      <Paging v-if="totalCount > 0" :page="page" :size="size" :total-count="totalCount" :total-pages="totalPages"
              @change-page="onPage" @change-size="onSize" />

      <div class="modal-btns">
        <p v-if="selected" class="picked">선택: <b>{{ selected.name }}</b> ({{ selected.loginId }})</p>
        <span class="spacer"></span>
        <button class="ghost" @click="close">취소</button>
        <button class="primary" :disabled="!selected" @click="choose">선택</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import Paging from './Paging.vue';

export default {
  name: 'SearchDialog',
  components: { Paging },
  data() {
    return {
      field: 'name', keyword: '',
      results: [], selected: null, message: '',
      page: 1, size: 10, totalCount: 0, totalPages: 0
    };
  },
  methods: {
    async doSearch() { this.page = 1; await this.load(); },
    onPage(p) { this.page = p; this.load(); },
    onSize(s) { this.size = s; this.page = 1; this.load(); },
    async load() {
      this.message = ''; this.selected = null;
      try {
        const res = await api.searchCustomers({ keyword: this.keyword, page: this.page, size: this.size });
        this.results = res.data.list || [];
        this.totalCount = (res.data.totalCount != null ? res.data.totalCount : res.data.total) || 0;
        this.totalPages = res.data.totalPages != null
          ? res.data.totalPages
          : Math.max(1, Math.ceil(this.totalCount / this.size));
      } catch (e) { this.message = e.message; }
    },
    pick(r) { this.selected = r; },
    choose() {
      if (!this.selected) return;
      this.$emit('select', {
        id: this.selected.id,
        loginId: this.selected.loginId,
        name: this.selected.name
      });
    },
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 70; }
.modal { background: #fff; padding: 22px; border-radius: 8px; width: 520px; max-width: 94vw; }
.modal h4 { margin: 0 0 12px; }
.search-bar { display: flex; gap: 8px; align-items: center; margin-bottom: 10px; }
.search-bar select { padding: 8px; border: 1px solid #d0d5dd; border-radius: 6px; }
.search-bar input { flex: 1; padding: 8px; border: 1px solid #d0d5dd; border-radius: 6px; }
.search-bar .spacer { flex: 0; }
.search-bar button { padding: 8px 16px; border: none; border-radius: 6px; cursor: pointer; }
.search-bar .primary { background: #2f6fed; color: #fff; }
.search-bar .ghost { background: #eef1f7; color: #33415c; }
.result-box { max-height: 260px; overflow: auto; border: 1px solid #eef; border-radius: 6px; }
.grid { width: 100%; border-collapse: collapse; }
.grid th, .grid td { border-bottom: 1px solid #eef; padding: 6px 8px; font-size: 12.5px; }
.grid th { background: #f0f3fa; position: sticky; top: 0; }
.grid td.center { text-align: center; }
.grid tr.sel { background: #eaf1ff; }
.grid tr:hover { background: #f6f9ff; cursor: pointer; }
.empty { text-align: center; color: #999; padding: 14px; }
.error { font-size: 13px; color: #d93636; margin: 0 0 8px; }
.picked { font-size: 13px; color: #2f6fed; margin: 0; }
.modal-btns { display: flex; align-items: center; gap: 8px; margin-top: 14px; }
.modal-btns .spacer { flex: 1; }
.modal-btns button { padding: 8px 16px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.modal-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.modal-btns .primary:disabled { background: #9db8ef; }
.modal-btns .ghost { background: #f5f5f5; }
</style>
